import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo, useState } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { Badge, Box, IconButton } from '@mui/material';
import { Notifications, NotificationsActive } from '@mui/icons-material';
import { preventDefault, useCallbacks } from 'shared/hooks/utils';
import { closeImportantEventsDialog, markAllEventsAsRead, openImportantEventsDialog, } from 'console/redux/main-actions';
import { UniversalDialog } from 'console/dialogs/universal';
import { unread_news_selector } from 'console/redux/news/selectors';
import { ImportantEventAndNews } from './content';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { selectDevId2Name } from 'entities/device/lib';
import { AnimatedBell } from '../icons/animated-icon/animated-bell';
import { useAnimationPermissions, useDesignPackage } from 'console/shared/hooks/helpers';
import { useKeybind } from 'console/left-menu/header/important-events/model/use-keybind';
export const EventsNotifier = memo(function EventsNotifier(props) {
    const open = useAppSelector((state) => state.important_events_dialog_open);
    const important_events = useAppSelector((state) => state.important_events);
    const unread_news_count = useAppSelector(unread_news_selector);
    const unread_count = important_events.unread + unread_news_count;
    const devid2name = useAppSelector(selectDevId2Name);
    const allow_design_package = useDesignPackage();
    const animation_permissions = useAnimationPermissions();
    const anim_icon = useMemo(() => allow_design_package && animation_permissions.bell_notification, [allow_design_package, animation_permissions.bell_notification]);
    const onOpenDialog = useCallbacks([
        preventDefault,
        useAction(openImportantEventsDialog),
    ]);
    const onMarkAllAsRead = useAction(markAllEventsAsRead);
    const onCloseDialog = useAction(closeImportantEventsDialog);
    const closeDialogAndMarkAllRead = useCallbacks([
        preventDefault,
        onCloseDialog,
        onMarkAllAsRead,
    ]);
    const [label, setLabel] = useState('Важные события');
    useKeybind({ onOpenDialog });
    return (_jsxs(Box, { ...props, sx: { mr: unread_count > 9 ? 1 : 0, ...props.sx }, children: [_jsx(IconButton, { onClick: onOpenDialog, className: 'events', children: _jsx(Badge, { badgeContent: unread_count, color: "error", sx: { '& .MuiBadge-badge': { top: 3 } }, children: unread_count > 0 ? (anim_icon ? (_jsx(AnimatedBell, {})) : (_jsx(NotificationsActive, {}))) : (_jsx(Notifications, {})) }) }), _jsx(UniversalDialog, { maxWidth: "sm", open: open, onClose: closeDialogAndMarkAllRead, onClick: preventDefault, title: label, contentWithZeroPadding: true, sx: {
                    '& .MuiPaper-root': {
                        minWidth: isMediumUI() ? 600 : undefined,
                    },
                }, children: _jsx(ImportantEventAndNews, { important_events_count: important_events.unread, unread_news_count: unread_news_count, important_events: important_events, devid2name: devid2name, onClose: onCloseDialog, onChangeLabel: setLabel }) })] }));
});
